import React, { useState } from 'react';
import { CarliPreferences } from '../hooks/useCarliConversations';
const styles: CarliPreferences['responseStyle'][] = ['Brief', 'Balanced', 'Detailed'];
export function CarliCustomize({
  preferences,
  onSave,
  onClose
}: {
  preferences: CarliPreferences;
  onSave: (next: CarliPreferences) => void;
  onClose: () => void;
}) {
  const [draft, setDraft] = useState<CarliPreferences>(preferences);
  return <form onSubmit={event => {
    event.preventDefault();
    onSave(draft);
    onClose();
  }} className="flex h-full flex-col gap-5 overflow-y-auto py-4" data-id="element-289" data-mp="1rpjsicfcyxho">
      <div data-id="element-290" data-mp="1i00995nqh1ma">
        <h3 className="text-sm font-semibold" data-id="element-291" data-mp="1hzie6cct4tfy">Customize Carli</h3>
        <p className="mt-1 text-xs leading-relaxed text-ink/55" data-id="element-292" data-mp="1dzzqx9xik69y">
          These preferences apply to every conversation you have with Carli in the portal.
        </p>
      </div>

      <label className="block" data-id="element-293" data-mp="25qnqwingb5m1">
        <span className="text-[11px] font-semibold uppercase tracking-wider text-ink/45" data-id="element-294" data-mp="25pl3ikpc7lav">What should Carli call you?</span>
        <input value={draft.displayName} onChange={event => setDraft({
        ...draft,
        displayName: event.target.value
      })} placeholder="Rich" className="mt-2 w-full rounded-xl border border-ink/15 bg-paper px-4 py-2.5 text-sm focus:border-[#BB5E40] focus:outline-none focus:ring-2 focus:ring-[#BB5E40]/20" data-id="element-295" data-mp="37ry30xtogokx" />
      </label>

      <div data-id="element-296" data-mp="2p0orkj0cjpqp">
        <span className="text-[11px] font-semibold uppercase tracking-wider text-ink/45" data-id="element-297" data-mp="2ozwzhi5yka56">Response length</span>
        <div className="mt-2 flex gap-2" data-id="element-298" data-mp="2u1m9qvlcwjs7">
          {styles.map(style => <button key={style} type="button" onClick={() => setDraft({
          ...draft,
          responseStyle: style
        })} aria-pressed={draft.responseStyle === style} className={`rounded-full border px-3.5 py-2 text-xs font-semibold transition-colors ${draft.responseStyle === style ? 'border-[#BB5E40] bg-[#BB5E40] text-cream' : 'border-ink/15 text-ink/60 hover:border-[#BB5E40]/40'}`} data-id="element-299" data-mp="2f3tw68zde5gn">
              {style}
            </button>)}
        </div>
      </div>

      <label className="block" data-id="element-300" data-mp="6w6tonou2qyx">
        <span className="text-[11px] font-semibold uppercase tracking-wider text-ink/45" data-id="element-301" data-mp="6x86awlhzlir">Anything Carli should always know?</span>
        <textarea value={draft.instructions} onChange={event => setDraft({
        ...draft,
        instructions: event.target.value
      })} rows={4} placeholder="e.g. Always lead with recovery value. We never discount below 45% of MSRP." className="mt-2 w-full resize-none rounded-xl border border-ink/15 bg-paper px-4 py-3 text-sm leading-relaxed focus:border-[#BB5E40] focus:outline-none focus:ring-2 focus:ring-[#BB5E40]/20" data-id="element-302" data-mp="zjji73ek18uv" />
      </label>

      <div className="flex gap-2" data-id="element-303" data-mp="1ic5691j7zv4w">
        <button type="submit" className="rounded-full bg-[#BB5E40] px-5 py-2.5 text-sm font-semibold text-cream transition-colors hover:bg-[#A34E33]" data-id="element-304" data-mp="1djc2ogzhmsue">
          Save preferences
        </button>
        <button type="button" onClick={onClose} className="rounded-full border border-ink/15 px-5 py-2.5 text-sm font-semibold text-ink/70 transition-colors hover:bg-cream" data-id="element-305" data-mp="315yoh7rkj7bh">
          Cancel
        </button>
      </div>
    </form>;
}